/** Shared Motion presets for the landing */

export const easeOut = [0.22, 1, 0.36, 1];

export const transitionSoft = {
  duration: 0.5,
  ease: easeOut,
};

export const viewportOnce = {
  once: true,
  margin: "-48px 0px -64px 0px",
  amount: 0.15,
};
